// extracted by mini-css-extract-plugin
export default {"nav-item":"NavigateItem_nav-item__a88YR","nav-icon":"NavigateItem_nav-icon__EMNe2","nav-title":"NavigateItem_nav-title__SAKap"};